<ng-container *transloco="let t">
  @let headerTpl = isHeaderTemplate(); @let comp = headerComponent(); @let actionsTpl = actions();

  <div [class]="headerClasses()">
    <div class="flex items-center gap-3" [class.flex-1]="isHeaderTemplate()">
      @if (headerTpl) {
      <ng-container [ngTemplateOutlet]="headerTpl" />
      } @else if (comp) {
      <ng-container *ngComponentOutlet="comp.type; inputs: comp.inputs" />
      } @else if (header()) {
      <div class="flex flex-col gap-0.5">
        <h2 class="font-semibold text-xl text-ink-strong">{{ header() }}</h2>
        @if (subtitle()) {
        <p class="text-xs text-ink-tertiary">{{ subtitle() }}</p>
        }
      </div>
      }
    </div>

    @if (showClose()) {
    <button type="button" class="p-1 rounded-lg bg-surface-subtle shrink-0 cursor-pointer" (click)="closed.emit()">
      <div class="flex items-center justify-center size-6 rounded-full text-ink-muted">
        <mat-icon class="size-2.5!" svgIcon="close" />
      </div>
    </button>
    }
  </div>

  <ng-content />

  @if (actionsTpl) {
  <div class="px-6 py-4 border-t border-stroke">
    <ng-container [ngTemplateOutlet]="actionsTpl" />
  </div>
  } @else if (primaryTitle() || secondaryTitle()) {
  <div class="flex justify-end items-center px-6 py-4 border-t border-stroke gap-3">
    @if (secondaryTitle()) {
    <dss-libs-ui-button
      [color]="secondaryButtonColor()"
      variant="outline"
      [label]="secondaryTitle()!"
      (clickOutput)="secondarySubmitted.emit()"
    />
    } @if (primaryTitle()) {
    <dss-libs-ui-button
      [color]="primaryButtonColor()"
      [label]="primaryTitle()!"
      [disabled]="primaryDisabled()"
      [isProcessing]="isLoading()"
      (clickOutput)="primarySubmitted.emit()"
    />
    }
  </div>
  }
</ng-container>
